// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","productCard":"products-card_productCard__jtmjb","opened":"products-card_opened__ovR4K","showDetails":"products-card_showDetails__zBFOn"};